// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { IAssetDetails } from './IAssetDetails';
import {
    IAssetDetailsFromJSON,
    IAssetDetailsFromJSONTyped,
    IAssetDetailsToJSON,
    IAssetDetailsToJSONTyped,
} from './IAssetDetails';
import type { IHeader } from './IHeader';
import {
    IHeaderFromJSON,
    IHeaderFromJSONTyped,
    IHeaderToJSON,
    IHeaderToJSONTyped,
} from './IHeader';

/**
 * 
 * @export
 * @interface IAssetDetailsResponse
 */
export interface IAssetDetailsResponse {
    /**
     * 
     * @type {IHeader}
     * @memberof IAssetDetailsResponse
     */
    common?: IHeader;
    /**
     * CorrelationId
     * @type {string}
     * @memberof IAssetDetailsResponse
     */
    correlation_id: string;
    /**
     * success or Failure Code. 0000 - Success 1002 - Invalid PAN 1003 - Ineligible BIN 1004 - Ineligible Device Wallets 1005 - PAN ineligible for Device Wallet 1006 - PAN ineligible for Merchants 1007 - Invalid passthruFromIdiSdk 1008 - Invalid Apple Wallet Certificate 1009 - Field Required 1010 - Issuer Card Art Registration incomplete 1991 - System Error 1993 - Unable to determine provision flow 1994 - PAN Ineligible at TSP 1995 - Unable to prepare encryptedPayload / Unable to prepare registrations / Unable to prepare encryptedPayload 1996 - Unable to create request to TSP / Unable to create request to Samsung / Unable to create request to Google 1997 - Unable to prepare passthruToIdiSdk 1998 - Failure in TSP response / Failure in Samsung response / Failure in Google response 1999 - Error in TSP response
     * @type {string}
     * @memberof IAssetDetailsResponse
     */
    status_code: string;
    /**
     * Description of failure. Conditional - required if statusCode is not 0000
     * @type {string}
     * @memberof IAssetDetailsResponse
     */
    status_description?: string | null;
    /**
     * Asset Id as provided in Get Wallet and Merchant List response
     * @type {string}
     * @memberof IAssetDetailsResponse
     */
    asset_id: string;
    /**
     * Asset Details data
     * @type {Array<IAssetDetails>}
     * @memberof IAssetDetailsResponse
     */
    asset_details?: Array<IAssetDetails>;
}

/**
 * Check if a given object implements the IAssetDetailsResponse interface.
 */
export function instanceOfIAssetDetailsResponse(value: object): value is IAssetDetailsResponse {
    if (!('correlation_id' in value) || value['correlation_id'] === undefined) return false;
    if (!('status_code' in value) || value['status_code'] === undefined) return false;
    if (!('asset_id' in value) || value['asset_id'] === undefined) return false;
    return true;
}

export function IAssetDetailsResponseFromJSON(json: any): IAssetDetailsResponse {
    return IAssetDetailsResponseFromJSONTyped(json, false);
}

export function IAssetDetailsResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): IAssetDetailsResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'common': json['common'] == null ? undefined : IHeaderFromJSON(json['common']),
        'correlation_id': json['correlationId'],
        'status_code': json['statusCode'],
        'status_description': json['statusDescription'] == null ? undefined : json['statusDescription'],
        'asset_id': json['assetId'],
        'asset_details': json['assetDetails'] == null ? undefined : ((json['assetDetails'] as Array<any>).map(IAssetDetailsFromJSON)),
    };
}

export function IAssetDetailsResponseToJSON(json: any): IAssetDetailsResponse {
    return IAssetDetailsResponseToJSONTyped(json, false);
}

export function IAssetDetailsResponseToJSONTyped(value?: IAssetDetailsResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'common': IHeaderToJSON(value['common']),
        'correlationId': value['correlation_id'],
        'statusCode': value['status_code'],
        'statusDescription': value['status_description'],
        'assetId': value['asset_id'],
        'assetDetails': value['asset_details'] == null ? undefined : ((value['asset_details'] as Array<any>).map(IAssetDetailsToJSON)),
    };
}

